import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import {
  Chapter,
  ConfirmEmail,
  ContributeAnecdote,
  Dashboard,
  Home,
  Login,
  Page404,
  Question,
  ResetPasswordConfirm,
  ResetPasswordRequest,
  Theme,
  Unlock,
} from "../../pages";
import { AudioBookPublic } from "../../pages/AudioBookPublic";
import { AcceptInvitation } from "../../pages/auth/AcceptInvitation";
import { GeneratedChapter } from "../../pages/GeneratedChapter";
import {
  AdminAuditLogs,
  AdminBookDetail,
  AdminContent,
  AdminDashboard,
  AdminInfra,
  AdminJobs,
  AdminPrintOrders,
  AdminSettings,
  AdminSubscriptions,
  AdminUserDetail,
  AdminUsers,
} from "../../pages/admin";
import { ImpersonationBanner } from "../ImpersonationBanner";
import { AdminLayout } from "./AdminLayout";
import { AdminRoute } from "./AdminRoute";
import { Layout } from "./Layout";
import { ProtectedRoute } from "./ProtectedRoute";

export const Router = () => {
  return (
    <BrowserRouter>
      <ImpersonationBanner />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route
          path="/welcome-guide"
          element={
            <Navigate to="/guide-pour-écrire-vos-mémoires-avec-sérénité.pdf" />
          }
        />
        <Route path="/reset-password" element={<ResetPasswordRequest />} />
        <Route path="/confirm-password" element={<ResetPasswordConfirm />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="/unlock" element={<Unlock />} />
        <Route path="/theme" element={<Theme />} />
        <Route path="/audio_book" element={<AudioBookPublic />} />
        <Route path="/contribute-anecdote" element={<ContributeAnecdote />} />

        {/* Admin Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminRoute />}>
            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="users/:id" element={<AdminUserDetail />} />
              <Route path="books/:id" element={<AdminBookDetail />} />
              <Route path="subscriptions" element={<AdminSubscriptions />} />
              <Route path="print-orders" element={<AdminPrintOrders />} />
              <Route path="infra" element={<AdminInfra />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="audit-logs" element={<AdminAuditLogs />} />
              <Route path="settings" element={<AdminSettings />} />
              {/* Old impersonation page and unknown admin pages */}
              <Route
                path="*"
                element={<Navigate to="/admin/users" replace />}
              />
            </Route>
          </Route>
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {/* Page with Nav bar */}
          <Route element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="chapter/:chapterNum" element={<Chapter />} />
            <Route
              path="chapter/:chapterNum/question/:questionNum"
              element={<Question />}
            />
            <Route
              path="generated_chapter/:chapterNum"
              element={<GeneratedChapter />}
            />
          </Route>
        </Route>

        {/* Catch All */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};
